import React from 'react'
import PropTypes from 'prop-types'
import {
  isInvestor,
  isInstitutional,
} from '../../../global/authentication/authentication-manager.js'

const ADVISOR_BLUE = 'u-decoBackgroundAdvisorBlue'
const INSTITUTIONAL_BLUE = 'u-decoBackgroundInstitutionalBlue'
const INVESTOR_BLUE = 'u-decoBackgroundInvestorBlue'

const makeLink = (href, target = '_blank') => {
  const LinkWrapper = ({ children, ...others }) => {
    return (
      <a
        className="Link u-flexGrow1"
        href={href}
        target={target}
        rel="noreferrer"
        {...others}
      >
        {children}
      </a>
    )
  }

  LinkWrapper.propTypes = {
    children: PropTypes.object,
  }

  LinkWrapper.displayName = 'LinkWrapper'
  return LinkWrapper
}

const getAssetClassColor = (assetName = '') => {
  const asset = assetName.replace(/[^\w]+/g, '').toLowerCase()
  let color
  switch (asset) {
    case 'domesticequity':
    case 'globalinternationalequity':
    case 'sectorequityspecialty':
    case 'internationalequity':
    case 'taxefficientequity':
    case 'equity':
      color = 'u-decoBackgroundBeyonce'
      break

    case 'assetallocation':
    case 'alternative':
      color = 'u-decoBackgroundCher'
      break

    case 'taxablefixedincome':
    case 'taxexemptincome':
    case 'taxexempt':
    case 'fixedincome':
    case 'modelsolutions':
    case 'moneymarket':
      color = 'u-decoBackgroundAdele'
      break

    default:
      color = ''
  }

  return color
}

const getSiteColor = () => {
  return isInvestor()
    ? INVESTOR_BLUE
    : isInstitutional()
    ? INSTITUTIONAL_BLUE
    : ADVISOR_BLUE
}

export { makeLink, getAssetClassColor, getSiteColor }
